import { Link, useLocation } from "react-router-dom";
import "./BottomNav.css";

import homeIcon from "../assets/icons/home_icon.png";
import homeIconActive from "../assets/icons/home_icon_active.png";
import wishIcon from "../assets/icons/wish_icon.png";
import wishIconActive from "../assets/icons/wish_icon_active.png";
import applyIcon from "../assets/icons/apply_icon.png";
import applyIconActive from "../assets/icons/apply_icon_active.png";
import accountIcon from "../assets/icons/account_icon.png";
import accountIconActive from "../assets/icons/account_icon_active.png";

const BottomNav = () => {
  const location = useLocation();

  return (
    <div className="bottom-nav">
      <Link to="/" className="nav-item">
        <img
          src={location.pathname === "/" ? homeIconActive : homeIcon}
          alt="Home"
          className="nav-icon"
        />
        <span className={location.pathname === "/" ? "active" : ""}>Home</span>
      </Link>

      <Link to="/wishlist" className="nav-item">
        <img
          src={location.pathname === "/wishlist" ? wishIconActive : wishIcon}
          alt="Wishlist"
          className="nav-icon"
        />
        <span className={location.pathname === "/wishlist" ? "active" : ""}>
        Favorites
        </span>
      </Link>

      <Link to="/messages" className="nav-item">
        <img
          src={location.pathname === "/messages" ? applyIconActive : applyIcon}
          alt="Messages"
          className="nav-icon"
        />
        <span className={location.pathname === "/messages" ? "active" : ""}>
          Applied
        </span>
      </Link>

      <Link to="/account" className="nav-item">
        <img
          src={location.pathname === "/account" ? accountIconActive : accountIcon}
          alt="Account"
          className="nav-icon"
        />
        <span className={location.pathname === "/account" ? "active" : ""}>
          Account
        </span>
      </Link>
    </div>
  );
};

export default BottomNav;
